import React from "react";
import styles from "./PromoteButton.scss";
import { Button } from "../../../../components/Button/Button";

export interface IPromoteButtonProps {
  onClick: any;
  isEnable: boolean;
  isLoading: boolean;
}

const PromoteButton = (props: IPromoteButtonProps): JSX.Element => {
  const { onClick, isEnable, isLoading } = props;
  return (
    <Button
      type="primary"
      className={!isEnable ? styles.disabledButton : styles.button}
      onClick={onClick}
      disabled={!isEnable}
      loading={isLoading}
    >
      <span className={styles.text}>{"Plati"}</span>
    </Button>
  );
};

export default PromoteButton;



// WEBPACK FOOTER //
// ./src/containers/AdPromotePage/PromotionPackages/PromoteButton/index.tsx